/**
 * Breadcrumbs — Navigation breadcrumbs for the brand editor.
 * SDK version: uses plain <button> elements instead of react-router Link.
 */

export default function Breadcrumbs({ items, onNavigate }) {
  return (
    <nav className="flex items-center gap-1.5 text-xs text-gray-400 mb-4">
      <button onClick={() => onNavigate('dashboard')} className="hover:text-gray-600 bg-transparent border-none cursor-pointer p-0">Brand</button>
      {items.map((item, i) => (
        <span key={i} className="flex items-center gap-1.5">
          <span>/</span>
          {item.step ? (
            <button onClick={() => onNavigate(item.step)} className="hover:text-gray-600 bg-transparent border-none cursor-pointer p-0">{item.label}</button>
          ) : (
            <span className="text-gray-600 font-medium">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}
